import React from 'react';
import html2pdf from 'html2pdf.js';

export const PDF_WIDTH = 1240;
export const PDF_HEIGHT = 1753;

export const PDF_CONFIG = {
  margin: [0, 0, 0, 0],
  filename: 'solution.pdf',
  image: { type: 'jpeg', quality: 0.98 },
  html2canvas: {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: '#fff',
    width: PDF_WIDTH,
  },
  jsPDF: {
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
    compress: true,
  },
  pagebreak: {},
};

export function usePdfExport() {
  const [isLoading, setIsLoading] = React.useState(false);

  const downloadPdf = async (elementRef: React.RefObject<HTMLDivElement>, filename: string = 'solution.pdf') => {
    if (!elementRef.current) {
      return;
    }

    await document.fonts.ready;

    // html2canvas can't copy cross-origin stylesheets (Google Fonts) into its
    // cloned iframe, so recharts SVG text falls back to the browser default font.
    // Mutate the real DOM elements before capture and restore them after.
    const rechartsTextEls = Array.from(elementRef.current.querySelectorAll<Element>('.recharts-text'));
    rechartsTextEls.forEach((el) => {
      el.setAttribute('font-family', '"Source Sans Pro", Arial, sans-serif');
    });

    const options = {
      ...PDF_CONFIG,
      filename,
    };

    setIsLoading(true);

    try {
      await html2pdf().set(options).from(elementRef.current).save();
    } catch (err) {
      throw new Error(`PDF export failed: ${(err as Error).message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return { downloadPdf, isLoading };
}
